import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: { showNav: true }
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import('../views/PayView.vue'),
      meta: { showNav: true }
    },
    {
      path: '/channel',
      name: 'channel',
      component: () => import('../views/ChannelView.vue'),
      meta: { showNav: true }
    },
    {
      path: '/info',
      name: 'user',
      component: () => import('../views/UserView.vue'),
      meta: { showNav: true }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: { showNav: false }
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('../components/SettingModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/bindemail',
      name: 'bindemail',
      component: () => import('../components/BindEmailModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/changePad',
      name: 'changePad',
      component: () => import('../components/ChangePasswdModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/pay_record',
      name: 'PayRecordModule',
      component: () => import('../components/PayRecordModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/strategy_detail',
      name: 'StrategyDetailModule',
      component: () => import('@/components/StrategyDetailModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/switch_head_icon',
      name: 'SwitchHeadIconModule',
      component: () => import('@/components/SwitchHeadIconModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/pay_result_page',
      name: 'PayResultModule',
      component: () => import('@/components/PayResultModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/app_pay_result_page',
      name: 'PayNeiGouResultModule',
      component: () => import('@/components/PayNeiGouResultModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/my_collect_page',
      name: 'ArticleCollectModule',
      component: () => import('@/components/ArticleCollectModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/pay_page',
      name: 'PayPageModule',
      component: () => import('@/components/PayPageModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/vip_equity',
      name: 'VipEquityModule',
      component: () => import('@/components/VipEquityModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/sigin_in_day',
      name: 'SiginInModule',
      component: () => import('@/components/active/SiginInModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/browsing_history',
      name: 'BrowsingHistoryModule',
      component: () => import('@/components/active/BrowsingHistoryModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/feedback',
      name: 'FeedbackModule',
      component: () => import('@/components/active/FeedbackModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/equity',
      name: 'EquityModule',
      component: () => import('@/components/active/EquityModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/pay_ranking_list',
      name: 'PayRamkingListModule',
      component: () => import('@/components/pay/PayRamkingListModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/article/edit_trends',
      name: 'EditTrendsModule',
      component: () => import('@/components/Article/EditTrendsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/view_user',
      name: 'UserView',
      component: () => import('@/components/otherUser/UserView.vue'),
      beforeEnter: (to) => ({
        path: '/info',
        query: { ...to.query }
      }),
      meta: { showNav: false }
    },
    {
      path: '/view_trends_info',
      name: 'TrendsDetailModule',
      component: () => import('@/components/Trends/TrendsDetailModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/view_attention_list',
      name: 'AttentionListModule',
      component: () => import('@/components/Article/AttentionListModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/view_fans_list',
      name: 'FansListModule',
      component: () => import('@/components/Article/FansListModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/article/edit_contribute',
      name: 'EditContributeModule',
      component: () => import('@/components/Article/EditContributeModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/view_tidings',
      name: 'TidingsModule',
      component: () => import('@/components/Tidings/TidingsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/tidings/fans',
      name: 'FansTidingsModule',
      component: () => import('@/components/Tidings/FansTidingsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/tidings/conments',
      name: 'CommentTidingsModule',
      component: () => import('@/components/Tidings/CommentTidingsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/tidings/like',
      name: 'LikeTidingsModule',
      component: () => import('@/components/Tidings/LikeTidingsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/tidings/ante',
      name: 'AnteTidingsModule',
      component: () => import('@/components/Tidings/AnteTidingsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/tidings/system',
      name: 'SystemTidingsModule',
      component: () => import('@/components/Tidings/SystemTidingsModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/sigin/view',
      name: 'signInModule',
      component: () => import('@/components/signIn/signInModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/article/view_works',
      name: 'WorksStateModule',
      component: () => import('@/components/Article/WorksStateModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/gif_shop_page',
      name: 'GifShopModule',
      component: () => import('@/components/pay/GifShopModule.vue'),
      meta: { showNav: false }
    },
    {
      path: '/points_shop_page',
      name: 'PointsShopModule',
      component: () => import('@/components/active/PointsShopModule.vue'),
      meta: { showNav: true }
    },
    {
      path: '/talk_trends_page',
      name: 'TalkTrendsModule',
      component: () => import('@/components/Trends/TalkTrendsModule.vue'),
      meta: { showNav: false }
    }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    localStorage.setItem('fromPath', from.fullPath)
  }
  next()
})

export default router
